import type { ReactNode } from 'react';

export const symbol_universal_currency_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-200q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h680q24 0 42 18t18 42v440q0 24-18 42t-42 18H140Zm0-60h680v-440H140v440Zm580-100h-85q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h105q12.75 0 21.38-8.63Q770-327.25 770-340v-105q0-10.83-7.12-17.92-7.11-7.08-18-7.08-10.88 0-17.88 7.08-7 7.09-7 17.92v85Zm-239.94-5q47.94 0 81.44-33.56t33.5-81.5q0-47.94-33.56-81.44t-81.5-33.5q-47.94 0-81.44 33.56t-33.5 81.5q0 47.94 33.56 81.44t81.5 33.5ZM240-595h85q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7H220q-12.75 0-21.37 8.62Q190-627.75 190-615v105q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08 7-7.09 7-17.92v-85ZM140-260v-440 440Z"
		/>
	</svg>
);
